import React, { useEffect } from 'react';
import { Image, StyleSheet, ActivityIndicator, ScrollView } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import TripSearchWidget from '../../components/TripSearchWidget/TripSearchWidget';
import { openAlert } from '../../store/actions/alert';
import { getTezEventApi } from '../../services/api/mytrips.service';
import { setEvents, fetchCventEvent } from '../../store/actions/events';
import {
  selectTezEvent,
  selectCventUrl,
  selectTezEventDetails,
} from '../../store/selectors/events.selector';
import { getToken } from '../../store/actions/auth';
import { guestTokenUserName } from '../../constants/Configs';
import { validateTripSearch } from '../../utils/search.utils';
import { setSearchInput, tripSearch } from '../../store/actions/search';
import { clearSelectedCarCache } from '../../store/actions/car';
import { selectedCarComponents } from '../../store/selectors/car.selector';
import EventAuthModal from '../../components/event/EventAuthModal';
import * as RootNavigation from '../../utils/navigationRef';
import { Screens } from '../../constants/ScreenNames';
import WhiteBoardTextMsg from '../../components/WhiteBoardTextMsg';
import { clearSeatSelected } from '../../store/actions/seat';

const EventHomeScreen = (props) => {
  const dispatch = useDispatch();
  const selectedCar = useSelector(selectedCarComponents);
  const eventData = useSelector(selectTezEvent);
  const cventUrl = useSelector(selectCventUrl);
  const event = useSelector(selectTezEventDetails);
  const searchTripLoading = useSelector((s) => s.search.tripResultsLoading);
  const onSearchHandler = async (searchInput, searchInputState) => {
    const validationResult = validateTripSearch(searchInput);
    if (validationResult.isFailed) {
      dispatch(openAlert({ message: validationResult.msg }));
    } else {
      await dispatch(clearSelectedCarCache(searchInput, selectedCar));
      dispatch(clearSeatSelected());
      await dispatch(setSearchInput(searchInput, searchInputState));
      dispatch(tripSearch());
    }
  };

  async function normalizeIncomingEventData(typeOfEvent) {
    if (typeOfEvent === undefined) {
      dispatch(openAlert({ message: 'Invalid event code' }));
    } else {
      const event = await getTezEventApi(typeOfEvent);
      await dispatch(setEvents(event));
      __DEV__ && console.log({ event });
      let additionalInfo = '';
      if (event) {
        additionalInfo = event?.groupKey + ',' + event?.eventMeeting?.CompanyKey;
      }
      await dispatch(getToken(guestTokenUserName, undefined, false, additionalInfo), '');
    }
  }

  useEffect(() => {
    async function eventAPI() {
      //get event value
      const value = window.location.search.split('value' + '=')[1];
      const cvent = window.location.pathname.startsWith('/event/');
      if (cvent) {
        dispatch(getToken(guestTokenUserName), '');
        dispatch(fetchCventEvent(window.location.pathname));
        if (cventUrl) {
          const cventValue = new URL(cventUrl).search.split('value' + '=')[1];
          window.history.pushState({}, '', window.location.origin + new URL(cventUrl).search);
          normalizeIncomingEventData(cventValue);
        }
      } else {
        normalizeIncomingEventData(value);
      }
    }
    eventAPI();
  }, [dispatch, cventUrl]);

  useEffect(() => {
    if (event?.eventMeeting?.StatusCode === '102') {
      RootNavigation.navigate(Screens.Receipt, {
        tripKey: event?.tripId,
        showInvoiceFirst: true,
        travelRequestId: 0,
      });
    }
  }, [event]);

  useEffect(() => {
    //to change logo
    const logo =
      eventData?.Logo?.Data == undefined
        ? require('../../assets/img/icons/logo-events.png')
        : { uri: `data:image/jpeg;base64,${eventData?.Logo?.Data}` };
    //const logo = require('../../assets/img/icons/logo-events.png');
    props.navigation.setOptions({
      headerTitle: <Image style={styles.headerLogoImg} source={logo} />,
    });
  }, [eventData, props.navigation]);
  //to avoid rerender
  if (eventData === undefined) {
    return <ActivityIndicator style={styles.loadingIndicator} />;
  } else if (eventData?.StatusMessage === undefined) {
    const message =
      eventData?.StatusMessage === undefined ? 'Invalid event code' : eventData?.StatusMessage;
    return <WhiteBoardTextMsg text={message} />;
  } else if (event?.eventMeeting?.StatusCode === '105') {
    //deactivated user
    return <WhiteBoardTextMsg text={eventData?.StatusMessage} />;
  } else if (eventData?.StatusMessage && eventData.StatusCode == '104') {
    return <WhiteBoardTextMsg text={eventData?.StatusMessage} />;
  } else {
    return (
      <ScrollView showsHorizontalScrollIndicator={false}>
        <EventAuthModal
          showEventModal={eventData?.RequireEventCode}
          eventKey={eventData?.CodeKey}
        />
        <TripSearchWidget onSearch={onSearchHandler} loading={searchTripLoading} />
      </ScrollView>
    );
  }
};

export const styles = StyleSheet.create({
  headerLogoImg: {
    height: 35,
    width: 250,
    resizeMode: 'contain',
  },
});
export default EventHomeScreen;
